// HabitatsDirectiveModal.jsx
import { Modal, Button, Table } from 'antd'; // Make sure to import necessary components

interface ModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}
const HabitatsDirectiveModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title='The Habitats Directive'
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key='submit' type='primary' onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <p>
        The habitats directive aims to protect species and habitats. The habitats listed in Annex I of this directive
        are referred to as Habitats of Community Interest (HCI). There are manuals for interpreting habitats, at both
        European and French levels. Annex I habitats may justify the creation of a Special Area of Conservation.
      </p>
      <p>
        Special area of conservation means « a site of Community importance designated by the Member States through a
        statutory, administrative and/or contractual act where the necessary conservation measures are applied for the
        maintenance or restoration, at a favourable conservation status, of the natural habitats and/or the populations
        of the species for which the site is designated » (see Council Directive 92/43/EEC).
      </p>
      <p>
        <strong>Extract from article 3 of the habitats directive:</strong>
        <br />« A coherent European ecological network of special areas of conservation shall be set up under the title
        Natura 2000. This network, composed of sites hosting the natural habitat types listed in Annex I and habitats of
        the species listed in Annex II, shall enable the natural habitat types and the species' habitats concerned to be
        maintained or, where appropriate, restored at a favourable conservation status in their natural range » (see
        Council Directive 92/43/EEC).
      </p>
      <p>
        <strong>Summary of article 6 paragraphs 1 to 4:</strong>
        <br />
        The Member States undertake, in particular, to:
        <br /> (1) establish conservation measures in Special Areas of Conservation that meet the ecological
        requirements of the natural habitat types listed in Annex I and the habitats of species listed in Annex II;
        <br /> (2) avoid the deterioration of natural habitats in Special Areas of Conservation;
        <br /> (3) approve a project on the site of a Special Area of Conservation if it does not adversely affect the
        conservation objectives of the site;
        <br /> (4) implement a compensatory measure if there are no alternative solutions to the project and if the
        project must be carried out for reasons of major public interest.
      </p>
      <p>
        To find out more about Natura 2000, click{' '}
        <a
          href='https://www.natura2000.fr/natura-2000/qu-est-ce-que-natura-2000'
          target='_blank'
          rel='noopener noreferrer'
        >
          here
        </a>
        .
      </p>
    </Modal>
  );
};
const HabitatsDirectiveSINPModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title="The Habitats Directive"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <p><strong>The habitats directive</strong></p>

      <p><strong>Species in Annexe II of the habitats directive</strong></p>
      <p>
        The Habitats Directive aims to protect species and habitats. Species listed in Annex II of the habitats directive are referred to as Species of Community Interest. Annex II species may justify the creation of a Special Area of Conservation. Special area of conservation means « a site of Community importance designated by the Member States through a statutory, administrative and/or contractual act where the necessary conservation measures are applied for the maintenance or restoration, at a favourable conservation status, of the natural habitats and/or the populations of the species for which the site is designated » (see Council Directive 92/43/EEC). The Natura 2000 network is composed of Special Areas of Conservation and Special Protection Areas classified by the Member States in accordance with Directive 79/409/EEC.
      </p>

      <p><strong>Extract from article 3 of the habitats directive</strong></p>
      <p>
        « A coherent European ecological network of special areas of conservation shall be set up under the title Natura 2000. This network, composed of sites hosting the natural habitat types listed in Annex I and habitats of the species listed in Annex II, shall enable the natural habitat types and the species' habitats concerned to be maintained or, where appropriate, restored at a favourable conservation status in their natural range » (see Council Directive 92/43/EEC).
      </p>

      <p><strong>Summary of article 6 paragraphs 1 to 4 of the habitats directive</strong></p>
      <p>
        The Member States undertake, in particular, to: (1) establish conservation measures in Special Areas of Conservation that meet the ecological requirements of the natural habitat types listed in Annex I and the habitats of species listed in Annex II; (2) avoid the deterioration of natural habitats in Special Areas of Conservation; (3) Approve a project on the site of a Special Area of Conservation if it does not adversely affect the conservation objectives of the site and implement a compensatory measure if there are no alternative solutions to the project and if the project must be carried out for reasons of major public interest.
      </p>
      <p>
        To find out more about Natura 2000, click{' '}
        <a
          href="https://www.natura2000.fr/natura-2000/qu-est-ce-que-natura-2000"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </p>

      <p><strong>Species in Annexe IV of the habitats directive</strong></p>
      <p>
        The Habitats Directive aims to protect species and habitats. Annex IV species are covered by article 13 of the Habitats Directive. « The Habitats Directive requires all Member States to establish a strict protection regime for species listed in Annex IV, both inside and outside Natura 2000 sites» (see Council Directive 92/43/EEC).
      </p>
      <p><strong>Article 13</strong></p>
      <p>
        « 1. Member States shall take the requisite measures to establish a system of strict protection for the plant species listed in Annex IV (b), prohibiting: (a) the deliberate picking, collecting, cutting, uprooting or destruction of such plants in their natural range in the wild; (b) the keeping, transport and sale or exchange and offering for sale or exchange of specimens of such species taken in the wild, except for those taken legally before this Directive is implemented.
      </p>
      <p>
        2. The prohibitions referred to in paragraph 1 (a) and (b) shall apply to all stages of the biological cycle of the plants to which this Article applies » (see Council Directive 92/43/EEC).
      </p>
      <p>
        To find out more about Natura 2000, click{' '}
        <a
          href="https://www.natura2000.fr/natura-2000/qu-est-ce-que-natura-2000"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </p>

      <p><strong>Species listed in Annexe V of the habitats directive</strong></p>
      <p>
        The Habitats Directive aims to protect species and habitats. Annex V species are covered by article 14 of the Habitats Directive.
      </p>
      <p><strong>Article 14</strong></p>
      <p>
        « 1. If, in the light of the surveillance provided for in Article 11, Member States deem it necessary, they shall take measures to ensure that the taking in the wild of specimens of species of wild fauna and flora listed in Annex V as well as their exploitation is compatible with their being maintained at a favourable conservation status.
      </p>
      <p>
        2. Where such measures are deemed necessary, they shall include continuation of the surveillance provided for in Article 11. Such measures may also include in particular: regulations regarding access to certain property, temporary or local prohibition of the taking of specimens in the wild and exploitation of certain populations, regulation of the periods and/or methods of taking specimens, application, when specimens are taken, of hunting and fishing rules which take account of the conservation of such populations, establishment of a system of licences for taking specimens or of quotas, regulation of the purchase, sale, offering for sale, keeping for sale or transport for sale of specimens, breeding in captivity of animal species as well as artificial propagation of plant species, under strictly controlled conditions, with a view to reducing the taking of specimens of the wild and assessment of the effect of the measures adopted » (see Council Directive 92/43/EEC).
      </p>
      <p>
        The following abbreviations are used by the SINP to specify the annex of the directive in which the species is listed: CDH2 = Annex II ; CDH4 = Annex IV ; CDH5 = Annex V
      </p>
      <p>
        To find out more about Natura 2000, click{' '}
        <a
          href="https://www.natura2000.fr/natura-2000/qu-est-ce-que-natura-2000"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        .
      </p>
    </Modal>
  );
};


const InvasiveModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title='Alien Species in the Mediterranean Zone of the Occitanie Region'
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key='submit' type='primary' onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8 }}>
        <p>
          A list of alien plants has been created for each biogeographical zone in the Occitanie region. The
          biogeographical zones are equivalent to those of the local plant programme (
          <a href='https://www.vegetal-local.fr/' target='_blank' rel='noopener noreferrer'>
            https://www.vegetal-local.fr/
          </a>
          ). The Narbonnaise en Méditerranée Regional Nature Park is part of the Occitanie region's Mediterranean
          biogeographical zone.
        </p>
        <p>
          This list distinguishes between <strong>invasive alien species</strong>,{' '}
          <strong>potentially invasive alien species</strong>, and
          <strong> non-invasive alien species</strong>.
        </p>

        <h3>Invasive Alien Plant</h3>
        <p>
          An alien plant in the Mediterranean zone of the Occitanie region whose behavior threatens ecosystems,
          habitats, or native species with negative ecological, economic, and health consequences. This category is
          subdivided into three categories:
        </p>
        <ul style={{ paddingLeft: 20 }}>
          <li>
            <strong>Major category</strong>: An alien plant taxon that occurs fairly frequently to frequently in the
            area under consideration and that regularly covers more than 50% of its area of presence.
          </li>
          <li>
            <strong>Emerging category</strong>: An alien plant taxon that occurs infrequently in the area under
            consideration and that regularly has an area coverage greater than 50%.
          </li>
          <li>
            <strong>Moderate category</strong>: An alien plant taxon that occurs fairly frequently to frequently in the
            area under consideration and whose areas of presence regularly cover less than 5% and sometimes more than
            25%.
          </li>
        </ul>

        <h3>Potentially Invasive Alien Plant</h3>
        <p>
          An alien plant absent from the Mediterranean zone of the Occitanie region whose invasive behavior is known in
          a territory with a similar climate, or an alien plant not very present in the territory under consideration
          but presenting populations suggesting future invasive behavior. This category is subdivided into two
          categories:
        </p>
        <ul style={{ paddingLeft: 20 }}>
          <li>
            <strong>Alert category</strong>: Alien plant taxon that occurs infrequently in the territory under
            consideration and that has a coverage in its areas of presence that is either always less than 5%, or
            regularly less than 5% and sometimes greater than 25%. In addition, it is cited as invasive in a
            geographically close area with a similar climate.
          </li>
          <li>
            <strong>Prevention category</strong>: Alien plant taxon a priori absent from the area under consideration
            and cited as invasive elsewhere. This includes:
            <ul>
              <li>Taxa a priori absent from the territory annexed to European Regulation n°1143/2014.</li>
              <li>Alien taxa a priori absent from the territory subject to regulation in France.</li>
              <li>
                Alien taxa cited as invasive in a geographically close territory with a similar climate, with an
                intermediate to high risk of proliferation (according to the modified Weber & Gut risk analysis).
              </li>
            </ul>
          </li>
        </ul>

        <h3>Non-invasive Alien Plant</h3>
        <p>
          An alien plant confirmed in the Mediterranean zone of the Occitanie region but which is not invasive or
          potentially invasive.
        </p>

        <p>
          To find out more about alien plants, click{' '}
          <a href='https://invmed.fr/src/home/index.php' target='_blank' rel='noopener noreferrer'>
            here
          </a>
          .
        </p>
      </div>
    </Modal>
  );
};
const FranceRedListModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title="Red List of Species in France"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8 }}>
        <p>
          The French Committee of IUCN, the Federation and network of National Botanical Conservatories, the French Agency for Biodiversity, and the National Museum of Natural History propose a Red List of vascular plants at the national level in France. This list was established according to the assessment of the risk of species extinction of the International Union for Conservation of Nature (IUCN). The IUCN uses the species as the unit for assessing the risk of extinction.
        </p>
        <p>
          The IUCN categories are as follows, in descending order of risk of extinction: <strong>Extinct (EX)</strong>, <strong>Extinct in the Wild (EW)</strong>, <strong>Critically Endangered (CR)</strong>, <strong>Endangered (EN)</strong>, <strong>Vulnerable (VU)</strong>, <strong>Near Threatened (NT)</strong>, <strong>Least Concern (LC)</strong>, <strong>Data Deficient (DD)</strong> and <strong>Not Evaluated (NE)</strong>.
        </p>
        <p>The risk assessment criteria are the following:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li><strong>Criterion A:</strong> Reduction in population size</li>
          <li><strong>Criterion B:</strong> Geographic range</li>
          <li><strong>Criterion C:</strong> Population size and reduction in population size</li>
          <li><strong>Criterion D:</strong> Population size</li>
          <li><strong>Criterion E:</strong> Quantitative estimates of the probability of extinction in the wild</li>
        </ul>
        <p>
          To find out more about the IUCN assessment of the risk of species extinction, click{' '}
          <a
            href="https://portals.iucn.org/library/node/10315"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>.
        </p>
      </div>
    </Modal>
  );
};
const ProtectedListModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title="Decree of 20 January 1982 establishing the list of protected plant species throughout France"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8 }}>
        <p><strong>Nationally protected plant species</strong></p>

        <p>
          This species is protected under the decree of January 1982, with prohibitions linked to this decree. The regulations concern wild specimens.
        </p>

        <p><strong>Extract from Article 1:</strong></p>
        <p>
          &laquo; In order to prevent the disappearance of endangered plant species and to enable the corresponding biotopes to be conserved, it is prohibited, at any time and throughout mainland France, to destroy, cut, mutilate, uproot, gather or remove, peddle, use, offer for sale, sell or buy all or part of the wild specimens of the species listed in appendix I to this order. &raquo;
        </p>

        <p><strong>Article 2:</strong></p>
        <p>
          &laquo; For the same purposes, it is forbidden to destroy all or part of the wild specimens present on national territory, with the exception of plots normally cultivated, of the species listed in appendix II of this order. &raquo;
        </p>

        <p><strong>Extract from Article III:</strong></p>
        <p>
          &laquo; For wild specimens growing on national territory of the species listed in appendix II, the collection or harvesting, use, transport and transfer, whether free of charge or in return for payment, are subject to authorisation from the minister responsible for nature protection after consulting the standing committee of the national nature protection council. &raquo;
        </p>

        <p>
          To find out more, click{' '}
          <a
            href="https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000865328/"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>.
        </p>
      </div>
    </Modal>
  );
};

const EuropeanRedListModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title="European Red List of Species"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8 }}>
        <p><strong>European red list of species</strong></p>

        <p>
          The European Environment Agency (EEA) proposes a European red list of species. This list was established according to the assessment of the risk of species extinction of the International Union for Conservation of Nature (IUCN). The IUCN uses the species as the unit for assessing the risk of extinction.
        </p>

        <p>
          The IUCN categories are as follows, in descending order of risk of extinction: <strong>Extinct (EX)</strong>, <strong>Extinct in the Wild (EW)</strong>, <strong>Critically Endangered (CR)</strong>, <strong>Endangered (EN)</strong>, <strong>Vulnerable (VU)</strong>, <strong>Near Threatened (NT)</strong>, <strong>Least Concern (LC)</strong>, <strong>Data Deficient (DD)</strong> and <strong>Not Evaluated (NE)</strong>.
        </p>

        <p>The risk assessment criteria are the following:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li><strong>Criterion A:</strong> Reduction in population size</li>
          <li><strong>Criterion B:</strong> Geographic range</li>
          <li><strong>Criterion C:</strong> Population size and reduction in population size</li>
          <li><strong>Criterion D:</strong> Population size</li>
          <li><strong>Criterion E:</strong> Quantitative estimates of the probability of extinction in the wild</li>
        </ul>

        <p>
          To find out more about the IUCN assessment of the risk of species extinction, click{' '}
          <a
            href="https://portals.iucn.org/library/node/10315"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>.
        </p>
      </div>
    </Modal>
  );
};
const IUCNRedListModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title="Global Red List of Species"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8 }}>
        <p><strong>Global red list of species</strong></p>

        <p>
          The global red list of species was established according to the assessment of the risk of species extinction of the International Union for Conservation of Nature (IUCN). The IUCN uses the species as the unit for assessing the risk of extinction. The IUCN categories are as follows, in descending order of risk of extinction: <strong>Extinct (EX)</strong>, <strong>Extinct in the Wild (EW)</strong>, <strong>Critically Endangered (CR)</strong>, <strong>Endangered (EN)</strong>, <strong>Vulnerable (VU)</strong>, <strong>Near Threatened (NT)</strong>, <strong>Least Concern (LC)</strong>, <strong>Data Deficient (DD)</strong> and <strong>Not Evaluated (NE)</strong>.
        </p>

        <p>The risk assessment criteria are the followings:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li><strong>Criterion A:</strong> Reduction in population size</li>
          <li><strong>Criterion B:</strong> Geographic range</li>
          <li><strong>Criterion C:</strong> Population size and reduction in population size</li>
          <li><strong>Criterion D:</strong> Population size</li>
          <li><strong>Criterion E:</strong> Quantitative estimates of the probability of extinction in the wild</li>
        </ul>

        <p>
          To find out more about the IUCN assessment of the risk of species extinction, click{' '}
          <a
            href="https://www.iucnredlist.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>.
        </p>
      </div>
    </Modal>
  );
};

const ZnieffModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title="Natural Zones of Ecological, Faunistic and Floristic Interest (ZNIEFF)"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8 }}>
        <p><strong>Natural zones of ecological, faunistic and floristic interest (ZNIEFF)</strong></p>

        <p>
          Natural zones of ecological, faunistic and floristic interest (ZNIEFF) are geographical areas ‘characterised by the presence of species or natural habitats that are rare, remarkable or characteristic of the national or regional natural heritage, justifying a heritage value greater than that of the surrounding environment’. The creation of a ZNIEFF is linked to the presence of species or habitats qualified as determinants for the ZNIEFF. However, their presence does not systematically lead to the creation of a ZNIEFF. ZNIEFFs have a range of functions, including guiding land-use planning.
        </p>

        <p>
          To find out more about ZNIEFFs in Occitanie, click{' '}
          <a
            href="https://www.occitanie.developpement-durable.gouv.fr/zones-naturelles-d-interet-ecologique-floristique-r8620.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>.
        </p>
      </div>
    </Modal>
  );
};

const dataSource = [
  {
    key: '1',
    code: 'NV1',
    description: 'List of plant species protected throughout metropolitan France: Article 1',
    link: 'http://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000865328&fastPos=1&fastReqId=1607863946&categorieLien=cid&oldAction=rechTexte',
  },
  {
    key: '2',
    code: 'NV2',
    description: 'List of plant species protected throughout metropolitan France: Article 2',
    link: 'http://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000865328&fastPos=1&fastReqId=1607863946&categorieLien=cid&oldAction=rechTexte',
  },
  {
    key: '3',
    code: 'NV3',
    description: 'List of plant species protected throughout metropolitan France: Article 3',
    link: 'http://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000865328&fastPos=1&fastReqId=1607863946&categorieLien=cid&oldAction=rechTexte',
  },
  {
    key: '4',
    code: 'NVM',
    description: 'List of marine plant species protected in metropolitan France: Article 1er',
    link: 'https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000689850/',
  },
  {
    key: '5',
    code: 'NO3',
    description: 'List of birds protected throughout the territory and the terms of their protection: Article 3',
    link: 'http://legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000021384277',
  },
  {
    key: '6',
    code: 'NO4',
    description: 'List of birds protected throughout the territory and the terms of their protection: Article 4',
    link: 'http://legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000021384277',
  },
  {
    key: '7',
    code: 'NO6',
    description: 'List of birds protected throughout the territory and the terms of their protection: Article 6',
    link: 'http://legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000021384277',
  },
  {
    key: '8',
    code: 'NM',
    description:
      'List of protected vertebrate species threatened with extinction in France and whose range extends beyond the territory of a single department: Article 1er',
    link: 'http://www.legifrance.gouv.fr/WAspad/UnTexteDeJorf?numjo=ATEN9980224A',
  },
  {
    key: '9',
    code: 'NI2',
    description: 'List of insects protected throughout the territory and the terms of their protection: Article 2',
    link: 'http://legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000465500',
  },
  {
    key: '10',
    code: 'NEC2',
    description: 'Protection of native crayfish in metropolitan France: Article 2',
    link: 'https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000471000/',
  },
];

const columns = [
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Status description',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'To learn more',
    dataIndex: 'link',
    key: 'link',
    render: (text: string) => (
      <a href={text} target="_blank" rel="noopener noreferrer">
        Link
      </a>
    ),
  },
];

const ProtectedSINPModal: React.FC<ModalProps> = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      title="National Protection Statuses in France"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="submit" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
    >
      <div style={{ paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8 }}>
        <p>
          In France, various national protection statuses have been established to safeguard biodiversity. The Natural
          Heritage Inventory Information System (SINP) assigns a specific national protection status to each taxon
          observed that falls under such regulations. Below, you will find the abbreviations or codes corresponding to
          the different types of national protection, along with a link to the relevant reference document.
        </p>

        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          bordered
          size="small"
        />
      </div>
    </Modal>
  );
};

export { HabitatsDirectiveModal, HabitatsDirectiveSINPModal, InvasiveModal, FranceRedListModal, ProtectedListModal, EuropeanRedListModal, IUCNRedListModal, ZnieffModal, ProtectedSINPModal };
